import { BaseResponse } from '../common';
import { CompanyResponse } from '../companies';

export type UserId = string;

export enum UserRole {
  admin = 1,
  client = 2,
  user = 3,
  affiliate = 4,
  noLogin = 5,
}

export interface AccountResponse {
  title: string;
  appId: string;
  logo?: string;
}

export interface UserResponse extends BaseResponse {
  id: UserId;
  token?: string;
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  position: string;
  image: string | File | undefined;
  role: UserRole;
  activation: string;
  isAdmin: string;
  permissions: any[];
  accounts: AccountResponse[];
  gcAccounts: AccountResponse[];
  companies: CompanyResponse[];
}

export interface AccountResponse {
  title: string;
  appId: string;
  logo?: string;
}

export type CompactUserResponse = Pick<UserResponse, 'id' | 'firstName' | 'lastName' | 'email'>;
